import DefaultEditor from "react-simple-wysiwyg";

export const TextEditor = ({ onChange, value, props }) => {
  return (
    <>
      <style>
        {`
          /* Scope list fixes to this editor only */
          .text-editor-wrapper [contenteditable="true"] ol,
          .text-editor-wrapper div[contenteditable="true"] ol {
            list-style-type: decimal !important;
            padding-left: 40px !important;
            margin: 10px 0 !important;
            list-style-position: outside !important;
          }

          .text-editor-wrapper [contenteditable="true"] ol li,
          .text-editor-wrapper div[contenteditable="true"] ol li {
            display: list-item !important;
            list-style-type: decimal !important;
            list-style-position: outside !important;
            margin-left: 0 !important;
            padding-left: 0 !important;
          }

          .text-editor-wrapper [contenteditable="true"] ul,
          .text-editor-wrapper div[contenteditable="true"] ul {
            list-style-type: disc !important;
            padding-left: 40px !important;
            margin: 10px 0 !important;
            list-style-position: outside !important;
          }

          .text-editor-wrapper [contenteditable="true"] ul li,
          .text-editor-wrapper div[contenteditable="true"] ul li {
            display: list-item !important;
            list-style-type: disc !important;
            list-style-position: outside !important;
            margin-left: 0 !important;
            padding-left: 0 !important;
          }
        `}
      </style>
      <div className="text-editor-wrapper">
        <DefaultEditor
          value={value}
          onChange={(e) => onChange(e.target.value)}
          containerProps={{
            style: {
              minHeight: "300px",
              border: "1px solid #ccc",
              borderRadius: "11px",
              backgroundColor: "white",
              maxHeight: "300px",
            },
          }}
          {...props}
        />
      </div>
    </>
  );
};
